module.exports = __webpack_public_path__ + "static/img/5.549bf91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/5.png
// module id = GOXB
// module chunks = 0